import { __decorate, __extends } from "tslib";
import { BlurTask } from './tasks/BlurTask';
import { FilterBase } from './FilterBase';
import { FilterUtils, proxyTo } from '../utils/FilterUtils';
import { Rectangle } from '@awayjs/core';
var BlurFilter = /** @class */ (function (_super) {
    __extends(BlurFilter, _super);
    function BlurFilter(props) {
        var _this = _super.call(this) || this;
        _this._hBlurTask = new BlurTask((props === null || props === void 0 ? void 0 : props.blurX) || 4, -1, true);
        _this._vBlurTask = new BlurTask((props === null || props === void 0 ? void 0 : props.blurY) || 4, -1, false);
        _this.addTask(_this._hBlurTask);
        _this.addTask(_this._vBlurTask);
        return _this;
    }
    BlurFilter.prototype.applyProps = function (props) {
        if ('blurX' in props) {
            this.blurX = props.blurX;
        }
        if ('blurY' in props) {
            this.blurY = props.blurY;
        }
    };
    Object.defineProperty(BlurFilter.prototype, "stepSize", {
        /**
         * The distance between two blur samples. Set to -1 to autodetect with acceptable quality (default value).
         * Higher values provide better performance at the cost of reduces quality.
         */
        get: function () {
            return this._hBlurTask.stepSize;
        },
        set: function (value) {
            this._hBlurTask.stepSize = value;
            this._vBlurTask.stepSize = value;
        },
        enumerable: false,
        configurable: true
    });
    BlurFilter.prototype.setRenderState = function (source, target, sourceRect, outRect, filterManage) {
        var pad = FilterUtils.meashureBlurPad(this.blurX, this.blurY, 3, false);
        var subPassTarget = filterManage.popTemp(source.width + pad.x, source.height + pad.y);
        // we not cut region, because in this case blur will emit invalid data on edge
        this._hBlurTask.inputRect.setTo(0, 0, source.width, source.height);
        // apply padding
        this._hBlurTask.destRect.setTo(pad.x, pad.y, source.width, source.height);
        // but we can use a clip to kill non-used
        this._hBlurTask.clipRect = new Rectangle(0, 0, source.width + pad.x, source.height + pad.y);
        this._vBlurTask.clipRect = this._hBlurTask.clipRect;
        // emit real
        // crop a dest rectanle
        this._vBlurTask.inputRect.setTo(pad.x, pad.y, outRect.width, outRect.height);
        this._vBlurTask.destRect.copyFrom(outRect);
        this._hBlurTask.source = source;
        this._hBlurTask.target = subPassTarget;
        this._vBlurTask.source = subPassTarget;
        this._vBlurTask.target = target;
        this._temp = [subPassTarget];
    };
    BlurFilter.filterName = 'blur';
    __decorate([
        proxyTo('_hBlurTask', 'amount')
    ], BlurFilter.prototype, "blurX", void 0);
    __decorate([
        proxyTo('_vBlurTask', 'amount')
    ], BlurFilter.prototype, "blurY", void 0);
    return BlurFilter;
}(FilterBase));
export { BlurFilter };
